module.exports = new __parcel__URL__("reparent-onboarding-light.775606c3.svg").toString();